<template>
    <div class="footer-container">
        <div class='footer-columns'>
            <Column1/>
            <Column2/>
        </div>
        <AwardsSection/>
        <BottomSection/>
    </div>
</template>

<script>

import BottomSection from '@/ecom/components/footer/BottomSection.vue';
import Separator from '@/ecom/components/separators/Separator.vue';
import Address from '@/ecom/components/footer/Address.vue';
import Column1 from '@/ecom/components/footer/Column1.vue';
import Column2 from '@/ecom/components/footer/Column2.vue';
import Column3 from '@/ecom/components/footer/Column3.vue';
import AwardsSection from '@/ecom/components/footer/AwardsSection.vue';

export default {
    components: {Address, Column1, Column2, Column3, BottomSection, Separator, AwardsSection},
    data(){
        return{
            year: new Date().getFullYear()
        }
    }
}
</script>
<style lang='scss' scoped>

.footer-container {
    border-top: 1px solid var(--maj-dark-green);
	display: flex;
    flex-direction: column;
    gap: 40px;
	min-height: var(--footer-height);
	padding-top: 40px;
    padding-bottom: 30px;

    padding-left: 300px;
    padding-right: 300px;

    @media(max-width: 1500px){
        padding-left: 100px;
        padding-right: 100px;
    }

    @media(max-width: 1000px){
        padding-left: 50px;
        padding-right: 50px;
    }

    @media(max-width: 768px){
        padding-left: 40px;
        padding-right: 40px;
    }
}

.footer-columns{
    display: flex;
    flex-wrap: wrap;
    gap: 100px;

    @media(max-width: 768px){
        flex-direction: column;
        gap: 48px;
    }
}

:deep(){
    .footer-column-links{
        margin-top: 30px;
        display:flex;
        flex-direction: column;
        gap: 8px;
        font-size: 0.957rem;
    }
}

:deep(){
    .footer-column-title{
        font-size: 1.11rem;
        font-weight: 600;
        color: var(--primary-colour-1);
    }
}

.separator-small{
    background-color: #e9ecef;
    height: 2px;
    width: 100%;
}

:deep(){
    .footer-link{
        text-decoration: none;
        color: var(--primary-colour-1);
        cursor: pointer;
    }
    .footer-link:hover {
        text-decoration: underline;
    }
}

</style>